import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { KeyboardTimePicker } from '@material-ui/pickers';

const styles = (theme) => ({
    root: {
        marginTop: '7px',
        marginBottom: '5px',
        '& .MuiInput-formControl': {
            marginTop: '10px'
        },
        '& .MuiSvgIcon-root': {
            color: 'black'
        }
    },
    dialog: {
        '& .MuiPickersClock-squareMask': {
            cursor: 'pointer'
        },
        '& .MuiPickersTimePickerToolbar-toolbarLeftPadding': {
            height: '20px'
        }
    },
    labelError: {
        color: theme.light.text.errorTitle,
        fontSize: '1.25rem',
        [theme.darkTheme]: {
            color: theme.dark.text.errorTitle
        }
    }
});
class DrcTimePicker extends React.Component {
    render() {
        const { classes, width, value, variant, onChange, label, style, helperText, required, InputProps, InputLabelProps, ...other } = this.props;
        return (
            <KeyboardTimePicker
                className={classes.root}
                style={{ width: width || '100%', ...style }}
                margin="dense"
                inputVariant={variant || 'outlined'}
                label={
                    required ? (
                        <span>
                            {label || ''} <span className={classes.labelError}>*</span>
                        </span>
                    ) : (
                        label || ''
                    )
                }
                value={value}
                onChange={onChange}
                helperText={helperText || ''}
                error={(helperText || '').length > 0}
                InputProps={{
                    ...InputProps
                }}
                InputLabelProps={{
                    ...InputLabelProps
                }}
                DialogProps={{ className: classes.dialog }}
                {...other}
            />
        );
    }
}

export default withStyles(styles)(DrcTimePicker);
